import React from "react";
import { useFormik } from 'formik';
import { validates } from './SSOValidation'
import { PageSubTitle } from "../../styled-components/shared";
import { useTranslation } from "react-i18next";
import Alert from "../../components/Alert";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Chip from '@material-ui/core/Chip';
import validURL from 'valid-url'
import Switch from "@material-ui/core/Switch";  // DLM-19585 - add a switch to control show/no show on mapping paramters
import { CLIENT_AUTH_TYPE } from '../../data/constants'
import ChipInput from 'material-ui-chip-input';
import { makeStyles } from "@material-ui/core";
import Checkbox from '@material-ui/core/Checkbox';

const AzureSSOConfig = (props) => {
    const useChipInputHelperTextStyles = makeStyles(() => ({
        root: {
            marginBottom: '0px',
            marginLeft: '0px'
        }
    }))();

    const { t } = useTranslation();
    const {
        StyledChipInput,
        SubHeader,
        CustomAlertText,
        FlexRow,
        ButtonContainer,
        StyledTextField,
        MButton,
        CheckboxHolder,
        ButtonStyle,
        isLoading,
        dataBaseSSO,
        ssoTestStatus,
        SSOSettings,
        ssoSetting,
        config,
        globalAppSettings,
        SSO_CONSTANTS,
        sc,
        onChangeDeactivationSwitch,
        handleSSOTestConfig,
        handleSave,
        StyledChip
    } = props;
    const validate = validates(validURL, t);
    let isProviderAzure = (SSOSettings && SSOSettings.ssoProvider === 2)
    var vals = {
        webClientId: isProviderAzure ? SSOSettings.webClientId : '',
        webRedirectURI: isProviderAzure && SSOSettings.webRedirectURI ? SSOSettings.webRedirectURI : config.WEB_REDIRECT_URI,
        androidClientId: isProviderAzure ? SSOSettings.androidClientId : '',
        androidRedirectURI: isProviderAzure && SSOSettings.androidRedirectURI ? SSOSettings.androidRedirectURI : config.ANDROID_REDIRECT_URI,
        enterpriseClientId: isProviderAzure ? SSOSettings.enterpriseClientId : '',
        enterpriseRedirectURI: isProviderAzure && SSOSettings.enterpriseRedirectURI ? SSOSettings.enterpriseRedirectURI : config.ELS_REDIRECT_URI,
        authorizationURL: isProviderAzure ? SSOSettings.authorizationURL : '',
        tokenURL: isProviderAzure ? SSOSettings.tokenURL : '',
        userInfoURL: isProviderAzure ? SSOSettings.userInfoURL : '',  // DLM-20088
        introspectionURL: isProviderAzure ? SSOSettings.introspectionURL : '',
        revokeURL: isProviderAzure ? SSOSettings.revokeURL : '',
        logoutURL: isProviderAzure ? SSOSettings.logoutURL : '',
        //roleParam: isProviderAzure ? SSOSettings.roleParam : '',
        adminRoleParam: isProviderAzure ? SSOSettings.adminRoleParam : '',
        managerRoleParam: isProviderAzure ? SSOSettings.managerRoleParam : '',
        adminRoles: isProviderAzure && SSOSettings.admin ? SSOSettings.admin : [],
        managerRoles: isProviderAzure && SSOSettings.manager ? SSOSettings.manager : [],
        userNameParam: isProviderAzure ? SSOSettings.userNameParam : '',
        authorizationScope: isProviderAzure ? SSOSettings.authorizationScope : '',
        siteNameParam: isProviderAzure ? SSOSettings.siteNameParam : '',
        ssoParameterMappingEnable: isProviderAzure ? SSOSettings.ssoParameterMappingEnable : false, //DLM-19585
        clientAuthType: (isProviderAzure &&  SSOSettings.clientAuthType) ? SSOSettings.clientAuthType: CLIENT_AUTH_TYPE.CLIENT_SECRET, //DLM-20746: default: None
        enablePKCE: isProviderAzure && SSOSettings.enablePKCE ? SSOSettings.enablePKCE : false,
        clientSecret: isProviderAzure ? SSOSettings.clientSecret : '',
        ssoProvider: 2
    }
    if (vals.clientAuthType === 0) {
        vals.enablePKCE = true;
    }
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: vals,
        validate,
        onSubmit: values => {
            console.log(values, 'values')
            handleSSOTestConfig(values)
        },
    });

    // DLM-19585
    const SwitchStyle = {
        display: "flex",
        alignItems: 'center',
        justifyContent: 'center',
        alignSelf: "flex-end",
        cursor: isLoading ? "wait" : "pointer",
    };

    const handleAddChip = (value, rolesArr, field) => {
        let arr = [...rolesArr, value]
        formik.setFieldValue(field, arr)
    }

    const handleDeleteChip = (chip, rolesArr, field) => {
        let arr = [...rolesArr].filter(el => {
            return el !== chip
        })
        formik.setFieldValue(field, arr)
    }
    return <form noValidate onSubmit={formik.handleSubmit}>
        <FlexRow style={{
            textAlign: "Left",
            display: "flex",
            justifyContent: "flexStart",
            marginBottom: "20px"
        }}>
            <SubHeader>{t("ssoActivationStatus")}:</SubHeader>
            <div style={{ width: "78%" }}>
                {SSOSettings.ssoLogin === true ? <Chip
                    label="Active"
                    variant="outlined"
                    style={{ color: "green", height: "24px", }}
                /> : <Chip
                    label="Inactive"
                    style={{
                        border: "1px solid rgba(255, 134, 146, 1)",
                        height: "24px",
                        backgroundColor: "rgba(255, 240, 241, 1)"
                    }}
                    variant="outlined"
                />}
            </div>
        </FlexRow>

        <div style={{ marginBottom: "15px" }} >
            <SubHeader>{t('clientAuthType')}  : </SubHeader>
            <RadioGroup style={{ display: 'flex', flexDirection: 'column', marginLeft: '32px' }}
                value={parseInt(formik.values.clientAuthType)}
                onChange={(event) => {
                    formik.handleChange(event);
                    formik.setFieldValue('enablePKCE', parseInt(event.target.value) === 0 ? true : false);
                }}
                onBlur={formik.handleBlur('clientAuthType')}>
                <FormControlLabel style={{ marginBottom: '-5px' }} value={1} control={<Radio />} name="clientAuthType" label={<SubHeader>Client Secret</SubHeader>} />
                <FormControlLabel style={{ marginBottom: '-5px' }} value={3} control={<Radio />} name="clientAuthType" label={<SubHeader>{t('clientAuthTypeTLS')}</SubHeader>} />
            </RadioGroup>
        </div>
        <FlexRow>
            <SubHeader>{t('authorizationScopeParam')}:</SubHeader>
        </FlexRow>
        <FlexRow >
            <StyledTextField
                variant="outlined"
                error={formik.errors.authorizationScope && formik.touched.authorizationScope ? true : false}
                onChange={formik.handleChange('authorizationScope')}
                onBlur={formik.handleBlur('authorizationScope')}
                value={formik.values.authorizationScope}
                helperText={formik.errors.authorizationScope && formik.touched.authorizationScope
                    ? formik.errors.authorizationScope : null}
                placeholder={t('enterAuthorizationScope')}
            />
        </FlexRow>
        <br />
        {ssoSetting.ssoLogin ? <PageSubTitle style={{ marginBottom: "15px" }}>{t('ssoEndpointURLS')}</PageSubTitle> : null}
        <FlexRow>
            <SubHeader>{t('authorizationEndpointURLS')}:</SubHeader>
        </FlexRow>
        <FlexRow style={{ marginBottom: "15px" }}>
            <StyledTextField
                variant="outlined"
                error={formik.errors.authorizationURL && formik.touched.authorizationURL ? true : false}
                onChange={formik.handleChange('authorizationURL')}
                onBlur={formik.handleBlur('authorizationURL')}
                value={formik.values.authorizationURL}
                helperText={formik.errors.authorizationURL && formik.touched.authorizationURL
                    ? formik.errors.authorizationURL : null}
                placeholder={t('enterAndroidAuthorizationEndpointURLS')}
            />
        </FlexRow>
        <FlexRow>
            <SubHeader>{t('tokenEndpointURL')}:</SubHeader>
        </FlexRow>
        <FlexRow style={{ marginBottom: "15px" }}>
            <StyledTextField
                variant="outlined"
                error={formik.errors.tokenURL && formik.touched.tokenURL ? true : false}
                onChange={formik.handleChange('tokenURL')}
                onBlur={formik.handleBlur('tokenURL')}
                value={formik.values.tokenURL}
                helperText={formik.errors.tokenURL && formik.touched.tokenURL ? formik.errors.tokenURL : null}
                placeholder={t('enterTheTokenEndpointURL')}
            />
        </FlexRow>
        
        <FlexRow >
            <SubHeader>{t('logoutEndpointURL')}:</SubHeader>
        </FlexRow>
        <FlexRow style={{ marginBottom: "15px" }}>
            <StyledTextField
                variant="outlined"
                error={formik.errors.logoutURL && formik.touched.logoutURL ? true : false}
                onChange={formik.handleChange('logoutURL')}
                onBlur={formik.handleBlur('logoutURL')}
                value={formik.values.logoutURL}
                helperText={formik.errors.logoutURL && formik.touched.logoutURL ? formik.errors.logoutURL : null}
                placeholder={t('enterLogoutEndpointURL')}
            />
        </FlexRow>

        <FlexRow>
            <SubHeader>{t('userInfoEndpointURL')}:</SubHeader>
        </FlexRow>
        <FlexRow style={{ marginBottom: "15px" }}>
            <StyledTextField
                variant="outlined"
                error={formik.errors.userInfoURL && formik.touched.userInfoURL ? true : false}
                onChange={formik.handleChange('userInfoURL')}
                onBlur={formik.handleBlur('userInfoURL')}
                value={formik.values.userInfoURL}
                helperText={formik.errors.userInfoURL && formik.touched.userInfoURL ? formik.errors.userInfoURL : null}
                placeholder={t('enterTheUserInfoEndpointURI')}
            />
        </FlexRow>
        <br />

        {ssoSetting.ssoLogin ? <PageSubTitle style={{ marginBottom: "15px" }}>{t('ssoEndPointParameters')} </PageSubTitle> : null}

        <FlexRow>
            <SubHeader>{t('userNameParam')}:</SubHeader>
        </FlexRow>
        <FlexRow style={{ marginBottom: "15px" }}>
            <StyledTextField
                variant="outlined"
                error={formik.errors.userNameParam && formik.touched.userNameParam ? true : false}
                onChange={formik.handleChange('userNameParam')}
                onBlur={formik.handleBlur('userNameParam')}
                value={formik.values.userNameParam}
                helperText={formik.errors.userNameParam && formik.touched.userNameParam
                    ? formik.errors.userNameParam : null}
                placeholder={t('enterTheUserName')}
            />
        </FlexRow>
        <FlexRow>

            <FormControlLabel
                control={
                    <Checkbox disabled={formik.handleBlur('ssoParameterMappingEnable')}
                        onChange={formik.handleChange('ssoParameterMappingEnable')}
                        checked={formik.values.ssoParameterMappingEnable===true ? true : false}
                    />
                }
                label={<SubHeader>{t('parameterMapping')}</SubHeader>}
            />
        </FlexRow>
        {!ssoSetting.ssoLogin === false && formik.values.ssoParameterMappingEnable === true ?
            <>
                <FlexRow>
                    <SubHeader>{t('siteName')}:</SubHeader>
                </FlexRow>
                <FlexRow style={{ marginBottom: "15px" }}>
                    <StyledTextField
                        variant="outlined"
                        error={formik.errors.siteNameParam && formik.touched.siteNameParam ? true : false}
                        onChange={formik.handleChange('siteNameParam')}
                        onBlur={formik.handleBlur('siteNameParam')}
                        value={formik.values.siteNameParam}
                        helperText={formik.errors.siteNameParam && formik.touched.siteNameParam ? formik.errors.siteNameParam : null}
                        placeholder={t('enterSiteName')}
                    />
                </FlexRow>
                <FlexRow>
                    <SubHeader>{t('adminRoleParam')}:</SubHeader>
                </FlexRow>
                <FlexRow style={{ marginBottom: "15px" }}>
                    <StyledTextField
                        variant="outlined"
                        error={formik.errors.adminRoleParam && formik.touched.adminRoleParam ? true : false}
                        onChange={formik.handleChange('adminRoleParam')}
                        onBlur={formik.handleBlur('adminRoleParam')}
                        value={formik.values.adminRoleParam}
                        helperText={formik.errors.adminRoleParam && formik.touched.adminRoleParam ? formik.errors.adminRoleParam : null}
                        placeholder={t('enterTheRole')}
                    />
                </FlexRow>
                <FlexRow>
                    <SubHeader>{t('adminRoles')}:</SubHeader>
                </FlexRow>
                <FlexRow style={{ marginBottom: "15px" }}>
                    <StyledChipInput
                        chipRenderer={(el) => {
                            return (
                                <StyledChip
                                    variant="outlined"
                                    label={el.value}
                                    onDelete={() => handleDeleteChip(el.value, formik.values.adminRoles, 'adminRoles')}
                                />)
                        }}
                        FormHelperTextProps={{
                            classes: {
                                root: useChipInputHelperTextStyles.root
                            }
                        }}
                        style={{ display: 'flex', width: '65%' }}
                        variant="outlined"
                        value={formik.values.adminRoles}
                        placeholder={t('adminRoles')}
                        alwaysShowPlaceholder={true}
                        error={formik.errors.adminRoles && formik.touched.adminRoles ? true : false}
                        helperText={formik.errors.adminRoles && formik.touched.adminRoles ? formik.errors.adminRoles : null}
                        onAdd={(chip) => handleAddChip(chip, formik.values.adminRoles, 'adminRoles')}
                        onDelete={(chip) => handleDeleteChip(chip, formik.values.adminRoles, 'adminRoles')}
                    />
                </FlexRow>
                <FlexRow>
                    <SubHeader>{t('managerRoleParam')}:</SubHeader>
                </FlexRow>
                <FlexRow style={{ marginBottom: "15px" }}>
                    <StyledTextField
                        variant="outlined"
                        error={formik.errors.managerRoleParam && formik.touched.managerRoleParam ? true : false}
                        onChange={formik.handleChange('managerRoleParam')}
                        onBlur={formik.handleBlur('managerRoleParam')}
                        value={formik.values.managerRoleParam}
                        helperText={formik.errors.managerRoleParam && formik.touched.managerRoleParam ? formik.errors.managerRoleParam : null}
                        placeholder={t('enterTheRole')}
                    />
                </FlexRow>
                <FlexRow>
                    <SubHeader>{t('managerRoles')}:</SubHeader>
                </FlexRow>
                <FlexRow style={{ marginBottom: "15px" }}>
                    <StyledChipInput
                        chipRenderer={(el) => {
                            return (
                                <StyledChip
                                    variant="outlined"
                                    label={el.value}
                                    onDelete={() => handleDeleteChip(el.value, formik.values.managerRoles, 'managerRoles')}
                                />)
                        }}

                        FormHelperTextProps={{
                            classes: {
                                root: useChipInputHelperTextStyles.root
                            }
                        }}
                        style={{ display: 'flex', width: '65%' }}
                        variant="outlined"
                        alwaysShowPlaceholder={true}
                        placeholder={t('managerRoles')}
                        value={formik.values.managerRoles}
                        error={formik.errors.managerRoles && formik.touched.managerRoles ? true : false}
                        helperText={formik.errors.managerRoles && formik.touched.managerRoles ? formik.errors.managerRoles : null}
                        onAdd={(chip) => handleAddChip(chip, formik.values.managerRoles, 'managerRoles')}
                        onDelete={(chip) => handleDeleteChip(chip, formik.values.managerRoles, 'managerRoles')}
                    />
                </FlexRow>
            </> :
            ""}
        <br />
        {ssoSetting.ssoLogin ? <PageSubTitle style={{ marginBottom: "15px" }}>{t('webPortal')}</PageSubTitle> : null}
        <FlexRow><SubHeader>{t('clientID')}:</SubHeader></FlexRow>

        <FlexRow style={{ marginBottom: "15px" }}>
            <StyledTextField
                variant="outlined"
                error={formik.errors.webClientId && formik.touched.webClientId ? true : false}
                onChange={formik.handleChange('webClientId')}
                onBlur={formik.handleBlur('webClientId')}
                value={formik.values.webClientId}
                helperText={formik.errors.webClientId && formik.touched.webClientId ? formik.errors.webClientId : null}
                placeholder={t('enterWebClientID')}
            />
        </FlexRow>
        {
            parseInt(formik.values.clientAuthType) === SSO_CONSTANTS.CLIENT_AUTH_TYPE.CLIENT_SECRET && <>
            <FlexRow>
                <SubHeader>{t('clientAuthTypeClientSecret')}:</SubHeader>
            </FlexRow>
                <FlexRow style={{ marginBottom: "15px" }}>
                    <StyledTextField
                        variant="outlined"
                        error={formik.errors.clientSecret && formik.touched.clientSecret ? true : false}
                        onChange={formik.handleChange('clientSecret')}
                        onBlur={formik.handleBlur('clientSecret')}
                        value={formik.values.clientSecret}
                        helperText={formik.errors.clientSecret && formik.touched.clientSecret ? formik.errors.clientSecret : null}
                        placeholder="Enter client secret"
                    />
                </FlexRow>
            </>
        }



        <FlexRow>
            <SubHeader>{t('webRedirectURI')}:</SubHeader>
        </FlexRow>
        <FlexRow style={{ marginBottom: "15px" }}>
            <StyledTextField
                variant="outlined"
                error={formik.errors.webRedirectURI && formik.touched.webRedirectURI ? true : false}
                onChange={formik.handleChange('webRedirectURI')}
                onBlur={formik.handleBlur('webRedirectURI')}
                value={formik.values.webRedirectURI}
                helperText={formik.errors.webRedirectURI && formik.touched.webRedirectURI
                    ? formik.errors.webRedirectURI : null}
                placeholder={t('enterTheWebRedirectURI')}
            />
        </FlexRow>

        <br />
        <ButtonContainer>
            {ssoSetting.ssoLogin ? <MButton
                style={
                    ButtonStyle, { marginRight: 10 }
                }
                disabled={isLoading}
                variant="contained"
                color="primary"
                type="submit"
            >
                {t('testSSO')}
            </MButton> : null}
            {ssoSetting.ssoLogin && ssoTestStatus === 1 && !dataBaseSSO ? <MButton
                style={
                    isLoading ? { opacity: "0.7", ...ButtonStyle } : ButtonStyle, { marginRight: 10 }
                }
                onClick={handleSave}
                variant="contained"
                color="primary"
                type="button"
            >
                {t('activeSSO')}
            </MButton> : null}
            {dataBaseSSO ? <MButton
                style={
                    ButtonStyle
                }
                onClick={() => onChangeDeactivationSwitch(false)}
                disabled={isLoading}
                variant="contained"
                color="primary"
                type="button"
            >
                {t('deactivate')}
            </MButton> : null}
        </ButtonContainer>
        <FlexRow
            style={{
                display: "flex",
                marginTop: 20
            }}
        >
            {/* <Alert severity="info">
                <CustomAlertText> {t('asteriskMarkAlertMsg')}</CustomAlertText>
            </Alert> */}
        </FlexRow>

        <br />


    </form>;
}
export default AzureSSOConfig;